(function(window, document, $, undefined){

    'use strict';
    window.animation = {};

    animation.init = function() {
        animation.contactButton();
        animation.accordion();
    }

    animation.accordion = function() {

        $('.accordion').on('show.bs.collapse', function (e) {

            var header = $("#" + e.target.id + '').parent();
            var icon = $("#" + e.target.id + '').prev().find('svg');

            gsap.to( icon, .4, {rotation: -90, transformOrigin:"50% 50%", attr:{ fill: "white" }}, 0);

        });

        $('.accordion').on('hide.bs.collapse', function (e) {

            var header = $("#" + e.target.id + '').parent();
            var icon = $("#" + e.target.id + '').prev().find('svg');

            gsap.to( icon, .4, {rotation: 0, transformOrigin:"50% 50%", attr:{ fill: "#333" }}, 0);

        });

    }

    function setToggleCookie( state )
    {
        Cookies.set('contactButton', state);
    }

    function getToggleCookie()
    {
        return Cookies.get('contactButton');
    }

    animation.contactButton =  function() {

        $( '.contact-toggle' ).click(function() {

            let button = $('.contactFloatButton');

            if ( $( this ).hasClass( 'open' ) ) {

                gsap.to( button, { x: 110, duration: .7, onComplete() {
                        $('.contact-toggle').removeClass('open');
                        $('.contact-toggle').addClass('close');

                    }
                });
                gsap.to('.toggle-close', { autoAlpha: 0 });
                gsap.to('.toggle-open', { autoAlpha: 1, duration: .5, delay: .7 });

                setToggleCookie( false );

            } else {

                gsap.to( button, { x: 0, duration: .7, onComplete() {
                        $('.contact-toggle').addClass('open');
                        $('.contact-toggle').removeClass('close');
                    }
                });
                gsap.to('.toggle-open', { autoAlpha: 0 });
                gsap.to('.toggle-close', { autoAlpha: 1, duration: .5, delay: .7 });

                setToggleCookie( true );
            }

        });
    }

    $(document).on( 'ready', animation.init );


})(window, document, jQuery);

(function($) {

    // Resolve search label issue
    $('.jet-search__field').attr('id', 'jet-search__field');
    $('.jet-search__label').attr('for', 'jet-search__field');
    $('.jet-search__label').prepend('<span class="sr-only">Search</span>');

    // Add main landmark to HTML
    $( "#content" ).attr('role', 'main');

    // Add role to GRPR cookie info bar
    $('#moove_gdpr_cookie_info_bar').attr('role', 'region');

    // Add text to Top Link
    $('#toTop span').addClass('sr-only').html('Scroll to Top');
    $('#toTop').attr('role', 'button')/*.wrap('<nav role="region" aria-label="Scroll to top page"></nav>')*/;

    $('.screen-reader-shortcut').attr('role', 'search');

    // Notification Slidedown
    if ($('.alert').length) {
        $('.alert').delay(2000).slideDown("slow");
    }

    $('.close-toggle').on('click', function() {

    });



})(jQuery);

